import styled from 'styled-components';
import { StyleColor } from '../../utils/styles-constants';

interface NotificationBarProps {
	isShown: boolean;
}


export const StyledNotificationBar = styled('div') `
	display: flex;
	flex-flow: column wrap;
	align-items: center;
	justify-content: center;
	position: fixed;
	bottom: 0;
	z-index: 95;
	height: 75px;
	line-height: 20px;
	background: ${StyleColor.Grey800};
	opacity: 0.8;
	width: 100%;
	color: ${StyleColor.White};
	font-size: 14px;
	font-style: italic;
	transform: ${ (props: NotificationBarProps) => props.isShown ? 'translate(0, 0)' : 'translate(0, 100%)'};
	transition: transform 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;

	@media print {
		display: none;
	}
`;

interface NotificationTextProps {
	color: string;
}

export const StyledNotificationText = styled('div') `
	color: ${(props: NotificationTextProps) => props.color};

	a {
		color: currentColor;
	}
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NotificationBar/styles.ts